module.exports = __webpack_public_path__ + "img/lot_ico1.747eef67.png";